import { Box, Stack } from '@mui/material'
import { memo } from 'react'
import FaIcon from 'src/components/shared/faIcon/FaIcon'

const SocialStats = ({ data, columns = 3 }) => {
  return (
    <Box
      sx={{
        py: 3,
        textAlign: 'center',
        display: 'grid',
        alignItems: 'center',
        typography: 'subtitle1',
        gridTemplateColumns: `repeat(${columns}, 1fr)`
      }}
    >
      {data.map(({ icon, label, value }) => (
        <Box
          key={label}
          sx={{
            gap: 0.5,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Stack direction='row' spacing={0.5} alignItems='center'>
            {icon && <FaIcon icon={icon} style={{ fontSize: 18 }} />}
            <Box
              component='span'
              sx={{
                typography: 'caption',
                color: 'text.secondary',
                fontWeight: 600
              }}
            >
              {label}
            </Box>
          </Stack>
          {value}
        </Box>
      ))}
    </Box>
  )
}

export default memo(SocialStats)
